//@flow
import * as actionTypes from './actionTypes';
import reduce from '../reduce';
import type { ReducerState$Type,Action } from './flowTypes'

const initialState:ReducerState$Type = {
    error: '',
    invoiceSubmitted: false,
    erosResultset: null,
    anyChanges: false,
    formData: {},
    reviewQuestions: [],
    formError: {},
    vendors: [],
    vendorsLoaded: false,
}

//In use : actionTypes.EROS_INV_SUBMIT_SUCCESS
const invoiceSubmittedSuccess = (state:ReducerState$Type) => {
    return {
        ...state,
        invoiceSubmitted: true,
        error: ''
    }
}
//In use : actionTypes.
const invoiceSubmittedError = (state:ReducerState$Type,action:Action) => {
    return {
        ...state,
        error: action.error
    }
}

//actionTypes.INV_SUBMITTED_COMPLETED
const invSubmittedCompleted = (state:ReducerState$Type) => {
    return {
        ...state,
        invoiceSubmitted: false
    }
}

const editVerifyFormDataSuccess=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        error: '',
        formData: action.formData,
        reviewQuestions: action.reviewQuestions
    }
}

const editVerifyFormDataError=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        error: action.error
    }
}

const updateFormError=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        formError: action.formError
    }
}

const refreshedErosVendors=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        vendors: action.vendors,
        vendorsLoaded: true
    }
}

const refreshedErosVendorsError=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        error: action.error
    }
}

export default reduce(initialState,{
    [actionTypes.EROS_INV_SUBMITTED_COMPLETED]: invSubmittedCompleted,
    [actionTypes.EROS_INV_SUBMIT_SUCCESS]: invoiceSubmittedSuccess,
    [actionTypes.EROS_INV_SUBMIT_ERROR]: invoiceSubmittedError,
    [actionTypes.EROS_EDIT_VERIFY_FORM_DATA_SUCCESS]: editVerifyFormDataSuccess,
    [actionTypes.EROS_EDIT_VERIFY_FORM_DATA_ERROR]: editVerifyFormDataError,
    [actionTypes.EROS_UPDATE_FORM_ERROR]: updateFormError,
    [actionTypes.REFRESH_EROS_VENDORS_SUCCESS]: refreshedErosVendors,
    [actionTypes.REFRESH_EROS_VENDORS_ERROR]: refreshedErosVendorsError
});


// WEBPACK FOOTER //
// ./src/redux/eros/reducer.js